(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["satgear-newsletter-spotlight"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('satgear-newsletter-signup')) {
  customElements.define('satgear-newsletter-signup', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.querySelector('form');
      const email = form.querySelector('input[type="email"]');
      const button = form.querySelector('button');
      const label = form.querySelector('[data-button-label]');
      const message = form.querySelector('[data-message]');
      const originalLabel = label.textContent;
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (this.busy || this.complete || !form.reportValidity()) return;
        this.busy = true;
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        label.textContent = this.dataset.pending;
        message.textContent = '';
        try {
          const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.dataset.siteId), {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2026-07-15' },
            body: JSON.stringify({ data: {
              type: 'subscription',
              attributes: {
                custom_source: 'SatGear footer newsletter',
                profile: { data: { type: 'profile', attributes: {
                  email: email.value.trim(),
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                } } }
              },
              relationships: { list: { data: { type: 'list', id: this.dataset.listId } } }
            } })
          });
          if (!response.ok) throw new Error('Subscription request was not accepted');
          this.complete = true;
          email.readOnly = true;
          message.textContent = this.dataset.success;
        } catch (error) {
          message.textContent = this.dataset.error;
        } finally {
          this.busy = false;
          button.disabled = Boolean(this.complete);
          form.removeAttribute('aria-busy');
          label.textContent = originalLabel;
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
